<template>
  <div id="offer-detail" class="p-l-15 p-r-15">
    <a :href="backHref" class="back-page" @click.prevent="onBack" v-show="showBackButton">
      <u>{{ $t('Offer.back') }}</u>
    </a>

    <h1 class="page-title">{{ $t('Offer.title_page', {number: offer.reference} ) }}</h1>
    <div class="publisher-infomation">
      <div class="pull-left published-by">
        {{ $t('OfferCandidateDetail.published_at_title', { date: publishedAt, name: publishedByFullName }) }}
      </div>
      <div class="pull-left m-l-30 m-r-5 group-contact-info">
        <i class="fa fa-phone"></i>
        <a v-if="typeof offer.author !== 'undefined'" :href=callTo>{{ offer.author.phone_display }}</a>
      </div>
      <div class="pull-left m-l-30 m-r-5 group-contact-info">
        <i class="fa fa-envelope"></i>
        <a v-if="typeof offer.author !== 'undefined'" :href=mailTo>{{ offer.author.email }}</a>
      </div>

      <div v-if="offer.author.function" class="pull-left m-l-30 m-r-5 group-contact-info">
        <i class="fa fa-user-md"></i>
        {{ offer.author.function }}
      </div>
    </div>

    <div class="clear-both"></div>

    <div class="container">

      <div class="row m-t-20">
        <label class="col-md-3 control-label">{{ $t('OfferInformation.entity') }}</label>
        <div class="col-md-6">
          <span>{{ offer.entity.name }}</span>
        </div>
      </div>

      <div class="row m-t-20">
        <label class="col-sm-12 col-md-3 control-label">{{ $t('OfferInformation.period') }}</label>
        <div class="col-sm-12 col-md-9">
          <div v-for="(period,index) in offer.offer_periods_attributes">
            <div class="row">
              <div class="col-md-6" v-bind:class="displaySeparator(period) ? 'separator offer-period' : ''">
                <div v-if="displayHistorical()">
                  <span v-bind:class="period.archived ? 'deleted-details' : ''">
                    {{ $t('OfferInformation.from_to', periodDateTimeParams(period.start_at, period.end_at, period.effective_work_minutes)) }}
                  </span>
                  <span v-if="period.archived" class="tag-period">{{ $t('OfferInformation.supp') }}</span>
                  <span v-else-if="period.archived_start_at == null && period.archived_effective_work_minutes == null && period.new" class="tag-period">
                    {{ $t('OfferInformation.new') }}
                  </span>
                  <div v-if="period.archived_start_at != null || period.archived_effective_work_minutes != null">
                    <span class="deleted-details deleted-details-archived">
                      <em>{{ $t('OfferInformation.from_to', periodDateTimeArchivedParams(period)) }}</em>
                    </span>
                  </div>
                </div>

                <span v-if="notArchived(period)">
                  {{ $t('OfferInformation.from_to', periodDateTimeParams(period.start_at, period.end_at, period.effective_work_minutes)) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr/>

      <div class="row m-t-20" v-if="entityHasHubs">
        <label class="col-md-3 control-label">{{ $t('OfferInformation.hub_name') }}</label>
        <div class="col-md-6">
          <span>{{ offer.hub.name }}</span>
        </div>
      </div>

      <div class="row m-t-20">
        <label class="col-md-3 control-label">{{ $t('OfferInformation.replaced_service') }}</label>
        <div class="col-md-6">
          <span class="multiselect__tag tag-without-close">{{ offer.replaced_service.name }}</span>
        </div>
      </div>

      <div class="row m-t-20">
        <label class="col-md-3 control-label">{{ $t('OfferInformation.replaced_occupation') }}</label>
        <div class="col-md-6">
          <span class="multiselect__tag tag-without-close">{{ offer.replaced_occupation.name }}</span>
        </div>
      </div>

      <hr/>

      <div v-if="offer.details" class="row m-t-20">
        <label class="col-md-3 control-label">{{ $t('OfferInformation.details') }}</label>
        <div class="col-md-6">
          <div v-html=offer.details ></div>
        </div>
      </div>

    </div>

    <hr/>
    <div v-if="displayApplyRefuseButton" class="align-items-center">
      <button class="btn btn-primary btn-cons" @click.prevent="apply()">{{ $t('buttons.accept') }}</button>
      <button class="btn btn-default btn-cons" @click.prevent="refuse()">{{ $t('buttons.not_available') }}</button>
    </div>

    <div v-else-if="offer.status == offerStatus.validated" class="message-validation">
      <label>
        <i style="color:green" class="fa fa-check-circle-o"></i>
        {{ $t('OfferInformation.validated') }}
      </label>
    </div>

    <div v-else-if="offer.status == offerStatus.waiting" class="message-validation">
      <label>{{ $t('OfferInformation.waiting_validation') }}</label>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters, mapActions } from 'vuex'
  import { offerStatus, offerModes } from '@/settings/offers'
  import { convertMinutesToDurationTime } from '@/helpers/timeCodes'
  import { sendCandidateAcceptOfferEvent, sendCandidateDeclineOfferEvent } from '@/helpers/at_internet/follow_candidate'
  import routesMixin from '@/mixin/routes'

  export default {
    name: 'OfferCandidateDetail',
    mixins: [routesMixin],
    computed: {
      ...mapGetters({
        offer: 'offers/offer'
      }),
      displayApplyRefuseButton(){
        return this.offer.can_apply_or_refuse
      },
      offerId() {
        return this.$route.params.id;
      },
      publishedAt() {
        return this.$options.filters.formatDateAtTime(this.offer.published_at);
      },
      publishedByFullName() {
        if(this.offer.published_by) {
          return `${this.offer.published_by.first_name} ${this.offer.published_by.last_name}`
        }
      },
      mailTo() {
        return ("mailto:" + this.offer.author.email)
      },
      callTo() {
        return ("tel:" + this.offer.author.phone)
      },
      offerStatus() {
        return offerStatus
      },
      showBackButton() {
        return this.isPreviousRoutes(['Dashboard', 'Offers'])
      },
      backHref() {
        var { href } = this.$router.resolve({ name: 'Offers' }, this.$route, true)
        return href
      },
      entityHasHubs() {
        return this.offer.entity.hubs != undefined && this.offer.entity.hubs.length > 1;
      }
    },
    methods: {
      ...mapActions({
        getOffer: 'offers/getOffer',
        refuseOffer: 'offers/refuseOffer',
        applyOffer: 'offers/applyOffer',
        setKeepOfferFilters: 'offers/setKeepFilters',
      }),
      periodDateTimeParams(start_at, end_at, effective_work_minutes) {
        let date = this.$options.filters.formatDate(start_at);
        let startAt = this.$options.filters.formatTime(start_at);
        let endAt = this.$options.filters.formatTime(end_at);
        let durationTime = "";

        if(effective_work_minutes && effective_work_minutes > 0){
          durationTime = "(" + convertMinutesToDurationTime(effective_work_minutes, false) + ")";
        }

        return {
          date: date,
          startAt: startAt,
          endAt: endAt,
          durationTime: durationTime
        };
      },
      redirectAndDisplayMessage(response, statusCode, message, routerName) {
        if(response.status == statusCode) {
          this.$router.push({ name: routerName })
          this.$store.dispatch('message/enable', { type: message.type, content: this.$i18n.t(message.key) })
        }
      },
      apply() {
        this.applyOffer(this.offerId).then((response) => {
          var message = { type: 'success', key: 'messages.offer_applied' }
          this.redirectAndDisplayMessage(response, 201, message, 'Dashboard')
          sendCandidateAcceptOfferEvent()
        })
      },
      refuse() {
        this.refuseOffer(this.offerId).then(response => {
          var message = { type: 'warning', key: 'messages.offer_refused' }
          this.redirectAndDisplayMessage(response, 201, message, 'Dashboard')
          sendCandidateDeclineOfferEvent()
        })
      },
      periodDateTime(startAt, endAt, effectiveWorkMinutes) {
        let date = this.$options.filters.formatDate(startAt)
        let startTime = this.$options.filters.formatTime(startAt)
        let endTime = this.$options.filters.formatTime(endAt)
        let durationTime = convertMinutesToDurationTime(effectiveWorkMinutes, false)

        return { date: date,
                 startAt: startTime,
                 endAt: endTime,
                 durationTime: effectiveWorkMinutes ? '(' + durationTime + ')' : '' }
      },
      onBack(event) {
        this.setKeepOfferFilters(true)
        this.$router.push({ name: 'Offers' })
      },
      displaySeparator(period) {
        return !period.archived || this.offer.is_expired
      },
      displayHistorical() {
        return this.offer.is_expired
      },
      notArchived(period) {
        return !period.archived && !this.offer.is_expired
      },
      periodDateTimeArchivedParams(period) {
        const {
          archived_start_at,
          archived_end_at,
          archived_effective_work_minutes,
          start_at,
          end_at,
          effective_work_minutes
        } = period;

        const date = archived_start_at ?
                    this.$options.filters.formatDate(archived_start_at) : this.$options.filters.formatDate(start_at);
        const startAt = archived_start_at ?
                        this.$options.filters.formatTime(archived_start_at) : this.$options.filters.formatTime(start_at);
        const endAt = archived_end_at ?
                      this.$options.filters.formatTime(archived_end_at) : this.$options.filters.formatTime(end_at);
        const effectiveWorkMinutes = archived_effective_work_minutes != null ? archived_effective_work_minutes : effective_work_minutes;
        const durationTime = effectiveWorkMinutes && effectiveWorkMinutes > 0 ?
                            `(${convertMinutesToDurationTime(effectiveWorkMinutes, false)})` : "";

        return { date, startAt, endAt, durationTime };
      },
    },
    mounted: function() {
      this.getOffer(this.offerId)
    }
  }
</script>

<style type="text/css">
  .offer-infomation .fa{
    min-width: 25px;
    font-size: 20px;
  }

  .clear-both {
    clear: both
  }

  a {
    color: #575a5d
  }

  @media only screen and (max-width: 768px) {
    .group-contact-info {
      clear: both;
      margin: 0;
    }
  }

  .message-validation {
   text-align: center;
  }

  .published-by {
    font-size: 90%;
  }

  .deleted-details {
    color: #F51153;
    text-decoration:line-through;
  }

  .tag-period {
    color: #F51153;
    background-color: #f7dfe5;
    border-radius: 8px;
    padding: 5px 10px;
    margin-left: 10px;
    font-weight: bold;
  }

  .offer-period {
    padding: 10px 0;
  }

  .separator {
    border-bottom: 0.1px solid #e1e1e2;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/OfferCandidateDetail.vue